export const selectSx = {
    width: '100%',
    borderRadius: '4px 4px 0px 0px',
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#DDDDDD',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#1BA1DB',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#1BA1DB',
    },
    '& .MuiSelect-select': {
        fontFamily: 'Rubik, sans-serif',
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: 400,
        textAlign: 'left',
        padding: '10px 32px 10px 14px',
        '&:focus': {
            backgroundColor: 'transparent',
        },
        '&:hover': {
            borderBottom: 'none',
        },
    },
    '& .MuiSelect-icon': {
        '& path': {
            fill: '#98A2B3',
        },
        top: '40%',
        right: '14px',
    },
};

export const menuItemSx = {
    padding: '5px 12px',
    gap: '8px',
    fontFamily: 'Rubik, sans-serif',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '24px',
    color: '#344054',
    display: 'flex',
    alignItems: 'center',
    pointerEvents: 'auto',
    '&.Mui-selected': {
        background: 'none',
    },
    '&:hover': {
        background: '#EFF8FF',
        fontWeight: 500,
    },
    '&.Mui-disabled': {
        color: '#565656',
        pointerEvents: 'auto',
    },
};

export const infoPanelContainerSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40%',
    position: 'absolute',
    height: '100%',
    top: '50%',
    right: 0,
    transform: 'translateY(-50%)',
    borderLeft: '1px solid #D1D5DB',
    zIndex: 1,
    background: '#fff',
};

export const infoPanelContentSx = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
};

export const infoIconWrapperSx = {
    '& svg': { color: '#6B7280', width: '24px', height: '24px' },
};

export const infoTextSx = {
    marginTop: '10px',
    fontFamily: 'Rubik, sans-serif',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '24px',
    color: '#000',
    textAlign: 'center',
};

export const paperSx = (menuWidth) => ({
    width: menuWidth || 0,
    overflowY: 'auto',
    marginTop: '3px',
    display: 'grid',
    gridTemplateColumns: '100%',
    position: 'relative',
});
